module.exports = __webpack_public_path__ + "img/20274768000160.be57ae82.png";